/* import __COLOCATED_TEMPLATE__ from './edit-flow.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { action, computed, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { Money, Currency } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
let EditFlow = (_dec = computed('userInfo.currencyCode'), _class = class EditFlow extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "sentry", _descriptor3, this);
    _defineProperty(this, "closeEditTarget", void 0);
    _defineProperty(this, "closeEditWithholding", void 0);
    _defineProperty(this, "isWithholding", void 0);
    _defineProperty(this, "previousWithholdingAmount", void 0);
    _defineProperty(this, "account", void 0);
    _defineProperty(this, "complete", void 0);
    _defineProperty(this, "close", void 0);
    _defineProperty(this, "didRemoveTarget", false);
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "page", '');
  }
  get currency() {
    return Currency[this.userInfo.currencyCode];
  }
  init(...args) {
    super.init(...args);
    set(this.automationSubaccountState, 'accountName', this.account.name);
    set(this.automationSubaccountState, 'accountId', this.account.id);
    if (this.isWithholding) {
      set(this, 'page', 'withholding');
    } else {
      set(this, 'page', 'target');
    }
  }
  async continue() {
    try {
      set(this, 'isLoading', true);
      await this.complete({
        withholdingBps: this.automationSubaccountState.withholdingBps,
        targetAmount: this.automationSubaccountState.targetAmount
      });
      set(this, 'page', 'success');
    } catch (e) {
      this.sentry.captureException(e);
      set(this, 'page', 'error');
    } finally {
      set(this, 'isLoading', false);
    }
  }
  removeTarget() {
    // If there isn't currently a target then this is just a close button so
    // the action should just dismiss the modal
    if (this.previousWithholdingAmount) {
      // Setting loading early to avoid flashing $0 on target input
      set(this, 'isLoading', true);
      const targetAmount = new Money.Builder().amount(0).currency(this.currency).build();
      set(this.automationSubaccountState, 'targetAmount', targetAmount);
      set(this, 'didRemoveTarget', true);
      this.continue();
    } else {
      this.close();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currency", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "currency"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "continue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "continue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeTarget", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeTarget"), _class.prototype), _class);
export { EditFlow as default };